import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, RefreshCw, CalendarCheck } from 'lucide-react';
export function TripleExtract() {
  const blocks = [{
    icon: <Droplets className="w-6 h-6 text-brand-gold" data-id="element-150" />,
    title: 'Mayor concentración'
  }, {
    icon: <RefreshCw className="w-6 h-6 text-brand-gold" data-id="element-151" />,
    title: 'Fácil de incorporar'
  }, {
    icon: <CalendarCheck className="w-6 h-6 text-brand-gold" data-id="element-152" />,
    title: 'Pensado para uso diario'
  }];
  return <section className="py-20 bg-white" data-id="element-153">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-154">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-heading font-bold text-brand-green mb-6" data-id="element-155">
          ¿Qué significa triple extracto?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-lg text-brand-brown/80 mb-12 leading-relaxed" data-id="element-156">
          El triple extracto busca aprovechar mejor los compuestos presentes en
          los hongos funcionales mediante un proceso de extracción más
          concentrado que una presentación tradicional. Esto permite entregar
          una fórmula práctica, fácil de incorporar y pensada para una rutina
          diaria de bienestar.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-157">
          {blocks.map((block, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex flex-col items-center p-6 bg-brand-beige/50 rounded-2xl border border-brand-beige" data-id="element-158">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm" data-id="element-159">
                {block.icon}
              </div>
              <h3 className="font-heading font-bold text-brand-green text-lg" data-id="element-160">
                {block.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}